import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { DestinationsService } from 'app/core/service/destinations.service';
import { GetDestinations, GetDestinationsSuccess, GetDestinationsError, GetDestinationById, GetDestinationByIdSuccess, GetDestinationByIdError } from '../actions/destinations.actions';
import { DestinationsAction } from '../constants/destinations.constants';
import { PostDestination, PostDestinationSuccess, PostDestinationError, PutDestination, PutDestinationSuccess, PutDestinationError, DeleteDestination, DeleteDestinationSuccess, DeleteDestinationError } from '../actions/destinations.actions';

@Injectable()
export class DestinationsEffects {
  getDestinations$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetDestinations>(DestinationsAction.GetDestinations),
      switchMap(() =>
        this.destinationsService.getDestinations().pipe(
          mergeMap((destinations: any) => {
            return of(new GetDestinationsSuccess(destinations));
          }),
          catchError((error) => {
            return of(new GetDestinationsError());
          }),
        )
      ),
    ),
  );

  getDestinationById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetDestinationById>(DestinationsAction.GetDestinationById),
      switchMap((action) =>
        this.destinationsService.getDestinationById(action.id).pipe(
          mergeMap((destination: any) => {
            return of(new GetDestinationByIdSuccess(destination));
          }),
          catchError((error) => {
            return of(new GetDestinationByIdError());
          }),
        )
      ),
    ),
  );

  postDestination$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PostDestination>(DestinationsAction.PostDestination),
      switchMap((action) =>
        this.destinationsService.postDestination(action.data).pipe(
          mergeMap((destination: any) => {
            return of(new PostDestinationSuccess(destination));
          }),
          catchError((error) => {
            return of(new PostDestinationError());
          }),
        )
      ),
    ),
  );
  
  putDestination$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PutDestination>(DestinationsAction.PutDestination),
      switchMap((action) =>
        this.destinationsService.putDestination(action.data).pipe(
          mergeMap((destination: any) => {
            return of(new PutDestinationSuccess(destination));
          }),
          catchError((error) => {
            return of(new PutDestinationError());
          }),
        )
      ),
    ),
  );
  
  deleteDestination$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteDestination>(DestinationsAction.DeleteDestination),
      switchMap((action) =>
        this.destinationsService.deleteDestination(action.id).pipe(
          mergeMap(() => {
            return of(new DeleteDestinationSuccess(action.id));
          }),
          catchError((error) => {
            return of(new DeleteDestinationError());
          }),
        )
      ),
    ),
  );

  constructor(
    private destinationsService: DestinationsService,
    private actions$: Actions,
  ) {}
}